import React, { useState, useEffect } from 'react';

import API from 'service/api';
import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';
import ContactGroupEditor from 'component/ContactGroupEditor';
import PreferredLanguageDropdown from 'component/dropdown/PreferredLanguageDropdown';

const OwnerInfo = ({ owner }) =>
{
  const [display_name,    setDisplayName   ]  = useState(owner?.display_name||'');
  const [remarks,         setRemarks       ]  = useState(owner?.remarks||null);
  const [lang,            setLanguage      ]  = useState(owner?.lang||'zh-HK');
  const [is_mobill,       setMonthlyBill   ]  = useState(owner?.is_mobill||false);
  const [is_rtn_envelope, setReturnEnvelope]  = useState(owner?.is_rtn_envelope||false);
  const [is_print_bill,   setPrintBill     ]  = useState(owner?.is_print_bill||false);

  const submitForm = (e) =>
  {
    e.target.disabled = true;
    let ownerDto = {
      ...owner,
      display_name: display_name.trim(),
      remarks: String(remarks||'').trim()||null,
      lang,
      is_mobill,
      is_rtn_envelope,
      is_print_bill,
    };

    API.editCustomer(ownerDto).then(resp => {
      if (resp.success) {
        PopMessage.show('已成功更新資料', '成功', 'success');
      } else {
        PopMessage.show(`無法更新資料: ${resp.msg}`, '失敗', 'danger');
      }
      e.target.disabled = false;
    });
  }

  //----------------------------------------
  // init
  useEffect(() => {
    setDisplayName(owner?.display_name||'');
    setRemarks(owner?.remarks||null);
    setLanguage(owner?.lang||'zh-HK');
    setMonthlyBill(owner?.is_mobill||false);
    setReturnEnvelope(owner?.is_rtn_envelope||false);
    setPrintBill(owner?.is_print_bill||false);
  }, [owner]);

  //----------------------------------------
  // render

  if (!owner) return null;
  return (<>
    <label className="field">
      <strong>稱謂/公司</strong>
      <input className="f-display-name" value={ display_name }
             onChange={e=>setDisplayName(e.target.value)}
             onBlur={e=>setDisplayName(e.target.value.trim())}/>
    </label>
    <div className="split-3">
      <label className="field">
        <strong>月結</strong>
        <input type="checkbox" checked={is_mobill}
               onChange={e=>setMonthlyBill(e.target.checked)} />
      </label>
      <label className="field">
        <strong>回郵信封</strong>
        <input type="checkbox" checked={is_rtn_envelope}
               onChange={e=>setReturnEnvelope(e.target.checked)} />
      </label>
      <label className="field">
        <strong>印收費單</strong>
        <input type="checkbox" checked={is_print_bill}
               onChange={e=>setPrintBill(e.target.checked)} />
      </label>
    </div>
    <label className="field">
      <strong>聯絡方法</strong>
      <ContactGroupEditor contacts={owner.contacts} />
    </label>
    <label className="field">
      <strong>偏好語言</strong>
      <PreferredLanguageDropdown className="f-lang" value={owner.lang} onChange={setLanguage} />
    </label>
    <label className="field">
      <strong>備註</strong>
      <textarea className="s-remarks" value={remarks||''}
        onChange={e=>setRemarks(e.target.value)}
        onBlur={e=>setRemarks(e.target.value.trim()||null)}>
      </textarea>
    </label>
    <div className="action-panel">
      <div className="slot"></div>
      <Protected allow={['ADMIN','OPERATOR']}>
        <button id="btn-submit" type="button" className="btn blue"
                onClick={ submitForm }>確定</button>
      </Protected>
    </div>
  </>);
}

export default OwnerInfo;